<template>
	<div class="fondoModal" style="background-color: rgba(255,255,255,0.3);">
		<div>
			<div style="max-width:400px;margin-top: 200px;">
				<div class="card text-left" style="background-color: rgba(255,255,255,0.4) !important;">
					<!-- <div class="card-header bg-danger text-white">Restaurar contraseña</div> -->
					<div class="card-body">
						<div style="position:relative;display:block;text-align:center;margin-bottom:20px;">
							<h5>
								<!-- <span class="fa fa-info-circle"></span> -->
								Reestablecer contraseña
							</h5>
						</div>
						<!-- <div class="alert alert-warning">
							<span class="fa fa-info mr-2"></span>
							Escribe el usuario del que quieres recuperar la contraseña
						</div> -->
						<div class="input-group">
							<div class="input-group-prepend">
								<span class="input-group-text">Usuario</span>
							</div>
							<input type="text" class="form-control" v-model="form.usuario">
							<div class="input-group-append">
								<button class="btn btn-sm btn-primary" style="width:30px;" @click="iniciar">
									<span class="fa fa-unlock"></span>
								</button>
								<button class="btn btn-danger" @click="cerrar">
									<span class="fa fa-close"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	data () {
		return {
			form: {
				usuario: ''
			}
		}
	},

	methods: {
		iniciar () {
			axios.post('core/php/api/password-restore/restore.php', this.form)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Correcto',
						mensaje: 'Se te ha enviado un e-mail con instrucciones para restaurar tu contraseña'
					})
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/login/restore.vue